/**
 * @fileoverview GET handler for the "/engagement/report_builder_2/:app_group_id/tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementReportBuilder2Tags } from "./constants";
import type { EngagementReportBuilder2TagsResult } from "./types";

export const getEngagementReportBuilder2Tags = reactQueryFetcherAdapter(
  engagementReportBuilder2Tags,
  (signal: AbortSignal, appGroupId: string): Promise<EngagementReportBuilder2TagsResult> => {
    return fetch(`/engagement/report_builder_2/${appGroupId}/tags`, "GET", {}, { signal });
  }
);
